import CardDesignerCardElementRotateControls from './CardDesignerCardElementRotateControls';

export default CardDesignerCardElementRotateControls;
